/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerPlay = createReactComponent("outline", "player-play", "IconPlayerPlay", [["path", { "d": "M7 4v16l13 -8z", "key": "svg-0" }]]);

export { IconPlayerPlay as default };
//# sourceMappingURL=IconPlayerPlay.mjs.map
